export const emailRegex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
export const passwordRegex = /^(?=.*[a-zA-Z]{6})(?=.*\d)[a-zA-Z\d]{7}$/;
export const enWordRegex = /\b[A-Za-z'-]+(?:\s+[A-Za-z'-]+)*\b/;
export const uaWordRegex = /^(?![A-Za-z])[А-ЯІЄЇҐґа-яієїʼ\s]+$/u;
